import { STORE_URLS_PERMISSIONS, MENU_DROPDOWN_PERMISSIONS } from "../Constants/permission";
import { getAuthDetails } from "../Common/cookiesHelper";
import { getPermissionsFromStorage } from "./permissionHelper";

export const getLoginType = () => {
    try {
        const { userTypeData } = getAuthDetails();
        return userTypeData?.login_type || "";
    } catch {
        return "";
    }
};


/** Check if current user is superadmin */
export const isSuperadminUser = () => getLoginType() === "superadmin" || getLoginType() === "merchant";
/** Check if user has a specific permission code */
export const hasStoreUrlPermissionCode = (permissionCode) => {
    const userPermissions = getPermissionsFromStorage();
    return userPermissions?.includes(permissionCode);
};

const userHasRequiredPermission = (requiredPermission) => {
    if (!requiredPermission) return true;
    if (Array.isArray(requiredPermission)) {
        return requiredPermission.some((code) => hasStoreUrlPermissionCode(code));
    }
    return hasStoreUrlPermissionCode(requiredPermission);
};


/** Convert route pattern (e.g. /edit-coupons/:couponsCode) to regex for matching current path */
const routePatternToRegex = (routePattern) => new RegExp("^" + routePattern.replace(/\/:[^/]+/g, "/[^/]+") + "$");

/** Get required permission for path: exact match first, then route patterns (e.g. /edit-coupons/:id) */
const getRequiredPermissionForPath = (path) => {
    if (typeof path !== "string") return null;
    const normalizedPath = path.replace(/\/$/, "") || "/";
    if (STORE_URLS_PERMISSIONS[normalizedPath]) return STORE_URLS_PERMISSIONS[normalizedPath];
    const routeKey = Object.keys(STORE_URLS_PERMISSIONS).find((key) => key.includes(":") && routePatternToRegex(key).test(normalizedPath));
    return routeKey ? STORE_URLS_PERMISSIONS[routeKey] : null;
};

export const hasStoreUrlPermission = (routeKey) => {
    if (isSuperadminUser()) return true;
    const requiredPermission = getRequiredPermissionForPath(routeKey);
    if (!requiredPermission) return true;
    return userHasRequiredPermission(requiredPermission);
};

/**
 * `ebt` is a fixed-slot CSV of payment flags: "1" food EBT, "2" cash EBT,
 * "3" gift card, "4" lottery payout, "5" disable debit card (QV-7233), with
 * "0" in every slot that is off. Read the flag by presence — the register app
 * appends new slots, so the lottery flag is no longer the last entry.
 */
export const hasEbtFlag = (ebtCsv, flag) =>
    String(ebtCsv ?? "")
        .split(",")
        .some((token) => token.trim() === String(flag));

/** Lottery pages are accessible only when the store or employee `ebt` list carries flag "4". */
export const isLotteryEbtAllowed = (...ebtCsvList) =>
    ebtCsvList.some((csv) => hasEbtFlag(csv, 4));

/** Check if user has access to a menu dropdown section (Employees, Inventory, Reporting, Store Settings, Promotions). */
export const hasMenuSectionAccess = (sectionText) => {
    if (isSuperadminUser()) return true;
    // Inventory contains the Composite Items and Container Deposit screens,
    // which are available to all signed-in users. Individual links still
    // enforce their own route permissions.
    if (sectionText === "Inventory") return true;
    const permissionCode = MENU_DROPDOWN_PERMISSIONS[sectionText];
    if (!permissionCode) return true;
    return hasStoreUrlPermissionCode(permissionCode);
};